import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { useDropzone } from 'react-dropzone';
import AlertCircle from '../../assets/svg/Feather/AlertCircle';
import { UPLOAD_FILESIZE_LIMIT } from '../../lib/constants';
import styles from './ImportDropzone.module.scss';

function ImportDropzone(props) {
  const onDrop = useCallback((acceptedFiles) => {
    let allGood = true;
    acceptedFiles.forEach((file) => {
      if (file.size > UPLOAD_FILESIZE_LIMIT.bytes) {
        props.dispatch({ type: 'dataManager/showFilesizeError' });
        props.dispatch({
          type: 'toast/show',
          payload: {
            text: `Oops, the file cannot be larger than ${UPLOAD_FILESIZE_LIMIT.mb}mb`,
            icon: AlertCircle,
            iconColor: '#ff3b30',
            dismissable: true,
          }
        });
        setTimeout(() => {
          props.dispatch({
            type: 'toast/dismiss'
          });
        }, 5000);
        allGood = false;
      }

      props.dispatch({ type: 'dataManager/addFileContents', payload: file });
    });

    if (allGood) {
      props.dispatch({ type: 'dataManager/updateAcceptedFiles', payload: acceptedFiles });
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: ['.gpx', '.kml'],
    onDrop,
    multiple: false
  });

  return (
    <section className={styles.container}>
      <div {...getRootProps({ className: styles.baseStyle })}>
        <input className="dropzone-input" {...getInputProps()} />
        <div className={styles.dropzoneContent}>
          <p>Drag & drop a .kml or .gpx file </p>
          <div className={styles.fakeButton}>
            Select from computer
          </div>
        </div>
      </div>
    </section>
  );
}

ImportDropzone.propTypes = {
  showSizeError: PropTypes.bool,
};

export default connect((model) => {
  return {
    showSizeError: model.dataManager.fileSizeError
  };
})(ImportDropzone);